import styled from '@emotion/styled';

import Button from 'components/field/Button';
import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const AnnouncementSlideContent = styled.div`
	overflow: hidden;
	height: 100%;
	width: 100%;
	position: relative;

	background: ${({ backgroundImage }) =>
		backgroundImage ? `url(${backgroundImage})` : 'linear-gradient(to bottom, #253999, var(--blue))'};
	background-size: cover;
	background-position: bottom;
	background-repeat: no-repeat;

	cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
`;

export const SlideContent = styled.div`
	position: relative;
	padding: 8rem 2rem;
	z-index: 10;

	@media ${Breakpoints.tablet} {
		padding: ${({ withTag }) => (withTag ? '5rem 2rem' : '2rem')};
	}
`;

export const BackgroundImage = styled(Image)`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	margin-top: 2rem;
`;

export const WhiteButton = styled(Button)`
	padding: 1rem 2rem;

	&.whiteButton {
		background: var(--alwaysWhiteColor);
		border-color: transparent;
		color: var(--blue);

		.button-text,
		.button-icon {
			color: var(--blue);
		}

		:not(.disabled):hover {
			background: var(--blue-10);

			.button-text,
			.button-icon {
				color: var(--blue);
			}
		}
	}

	&.outline {
		background: transparent;
		border-color: var(--alwaysWhiteColor);
		color: var(--alwaysWhiteColor);

		.button-text,
		.button-icon {
			color: var(--alwaysWhiteColor);
		}

		:not(.disabled):hover {
			background: var(--alwaysWhiteColor);
			color: var(--blue);

			.button-text,
			.button-icon {
				color: var(--blue);
			}
		}
	}
`;

export const CornerTag = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	background: var(--black-90);
	color: var(--white);
	padding: 1rem 2rem;
	border-radius: 0 0 2rem 0;

	body[dir='rtl'] & {
		left: unset;
		right: 0;
		border-radius: 0 0 0 2rem;
		padding: 0.5rem 2rem;
	}
`;
